/* tslint:disable:no-input-rename */
import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { PopoverService } from '@mandae/ng-popover';
import { fromEvent, iif, of, Subscription } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

@Directive({
  selector: '[mandaePopover]'
})
export class PopoverDirective implements AfterViewInit, OnDestroy {

  @Input('mandaePopover')
  public text: string;

  @Input('mandaePopoverTitle')
  public title = '';

  @Input('mandaePopoverTrigger')
  public trigger: 'click' | 'hover' = 'hover';

  private eventSubscription: Subscription;

  constructor(
    private popoverService: PopoverService,
    private elementRef: ElementRef,
  ) { }

  public ngAfterViewInit(): void {
    this.eventSubscription = fromEvent(this.elementRef.nativeElement, this.trigger === 'click' ? 'click' : 'mouseenter')
      .pipe(
        map(() => this.popoverService.createPopover({
            attachTo: this.elementRef,
            data: {
              content: this.text,
              title: this.title,
              buttons: [],
              foregroundColor: '#FFFFFF',
              backgroundColor: '#2A2A2A',
              close: ref => ref.close(),
            },
            closeOnBackdropClick: true,
            disposeOnNavigation: true,
          })),
        switchMap(ref => iif(
          () => this.trigger !== 'click',
          fromEvent(this.elementRef.nativeElement, 'mouseleave').pipe(
            tap(() => ref.close()),
          )
        )),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }
}
